// extracted by mini-css-extract-plugin
export default {"section__loading":"Loading_section__loading__Ml11B"};